import React, { useEffect, useState } from 'react';
import { Paper, Table, TableHead, TableRow, TableCell, TableBody, Chip, Stack, Typography, Alert, Button } from '@mui/material';
import apiClient from '../../api';
import { useAuth } from '../../context/AuthContext';

export default function SafetyIncidentsList() {
  const { user } = useAuth();
  const canQuerySamsara = user?.role === 'admin' || user?.role === 'company_admin';
  const [rows, setRows] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    if (!canQuerySamsara) return;
    setLoading(true);
    setError(null);
    try {
      const res = await apiClient.get('/samsara/safety/events?limit=100');
      const items = Array.isArray(res.data?.data) ? res.data.data : [];
      setRows(items);
    } catch (err) {
      if (err?.response?.status === 400) {
        setError('No Samsara connection is configured for this company.');
      } else {
        setError(err?.response?.data?.message || err.message || 'Failed to load safety events');
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!canQuerySamsara) return;
    load();
  }, [canQuerySamsara]);

  if (!canQuerySamsara) return null;

  if (error) {
    return (
      <Paper sx={{ p: 2 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
          <Typography variant="h6">Safety Incidents</Typography>
          <Button size="small" onClick={load} disabled={loading}>Refresh</Button>
        </Stack>
        <Alert severity="info">{error}</Alert>
      </Paper>
    );
  }

  return (
    <Paper sx={{ p: 2 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
        <Typography variant="h6">Safety Incidents</Typography>
        <Button size="small" onClick={load} disabled={loading}>Refresh</Button>
      </Stack>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Time</TableCell>
            <TableCell>Vehicle</TableCell>
            <TableCell>Driver</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Severity</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5} sx={{ color: 'text.secondary' }}>No incidents found.</TableCell>
            </TableRow>
          ) : rows.map((e, idx) => (
            <TableRow key={idx} hover>
              <TableCell>{e.timestamp ? new Date(e.timestamp).toLocaleString() : '-'}</TableCell>
              <TableCell>{e.vehicle?.name || e.vehicleName || '-'}</TableCell>
              <TableCell>{e.driver?.name || e.driverName || '-'}</TableCell>
              <TableCell>{e.type || e.eventType || '-'}</TableCell>
              <TableCell>
                <Chip size="small" label={e.severity || 'unknown'} color={String(e.severity).toLowerCase() === 'high' ? 'error' : (String(e.severity).toLowerCase() === 'medium' ? 'warning' : 'default')} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}


